export default __webpack_public_path__ + "static/media/001-forest.a7889b72.svg";